import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import empty from "is-empty";
import { SettingsSelectors } from "src/redux/Settings/selectors";
import { AuthSelectors } from "src/redux/Auth/selectors";
import { SettingsActions } from "src/redux/Settings/actions";
import * as Validators from "src/utils/validators";
import { ModalActions } from "src/redux/Modal/actions";
import Button from "src/components/common/Button";

import styles from "./styles.module.scss";

const placeholders = Object.freeze({
    accountNo: "ex) 1234567890",
    ksfcAccountNo: "ex) 123456789012",
});

export default () => {
    const dispatch = useDispatch();
    const isTraderRole = useSelector(AuthSelectors.IsTraderRole);
    const ksdAccountSettings = useSelector(
        SettingsSelectors.KsdAccountSettings
    );
    const ksfcAccountSettings = useSelector(
        SettingsSelectors.KsfcAccountSettings
    );
    const [accountNo, setAccountNo] = useState(ksdAccountSettings?.accountNo);
    const [ksfcAccountNo, setKsfcAccountNo] = useState(
        ksfcAccountSettings?.accountNo
    );
    const isAccountSettingValid =
        Validators.isKsdAccountNoValid(accountNo) &&
        Validators.isKsfcAccountNoValid(ksfcAccountNo);

    useEffect(() => {
        dispatch(
            SettingsActions.UpdateAccountSettings(
                "KSD",
                empty(accountNo)
                    ? {}
                    : {
                          accountNo,
                      }
            )
        );
    }, [accountNo]);
    useEffect(() => {
        dispatch(
            SettingsActions.UpdateAccountSettings(
                "KSFC",
                empty(ksfcAccountNo)
                    ? {}
                    : {
                          accountNo: ksfcAccountNo,
                      }
            )
        );
    }, [ksfcAccountNo]);

    const displayInput = (fieldName, value, setValue, validFunc) => {
        return (
            <div
                className={[
                    styles.input,
                    validFunc(value) ? "" : styles.error,
                ].join(" ")}
            >
                <input
                    placeholder={placeholders[fieldName]}
                    className={styles[fieldName]}
                    data-testid={`account-settings-${fieldName}`}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                />
            </div>
        );
    };

    return (
        <div className={styles.accountSettings}>
            <div className={[styles.section, styles.splitter].join(" ")}>
                <div className={styles.title}>KSD Account Code</div>
                {displayInput(
                    "accountNo",
                    accountNo,
                    setAccountNo,
                    Validators.isKsdAccountNoValid
                )}
            </div>
            <div className={styles.section}>
                <div className={styles.title}>KSFC Account Code</div>
                {displayInput(
                    "ksfcAccountNo",
                    ksfcAccountNo,
                    setKsfcAccountNo,
                    Validators.isKsfcAccountNoValid
                )}
            </div>
            <div className={styles.footer}>
                <Button
                    value="Save"
                    onClick={() =>
                        dispatch(SettingsActions.SaveCPTYSettingsForEveryRole())
                    }
                    disabled={!isTraderRole || !isAccountSettingValid}
                    dataTestId="save-account-settings"
                />
                <Button
                    onClick={() => dispatch(ModalActions.Close())}
                    value="Cancel"
                    dataTestId="cancel-account-settings"
                    color="reversedWhite"
                />
            </div>
        </div>
    );
};
